// Per-user-browser card visibility preferences.
// Persisted in localStorage. Other components read via the `useHiddenCards`
// hook and render cards conditionally on `!hidden[cardKey]`.

import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "kinntegra.hiddenCards.v1"; // { [page]: { [cardKey]: true } }

export const DASHBOARD_CARDS = [
  { key: "total_clients",   label: "Total Clients" },
  { key: "total_folios",    label: "Total Folios" },
  { key: "avg_portfolio",   label: "Avg. Portfolio" },
  { key: "overall_xirr",    label: "Overall XIRR" },
  { key: "cams",            label: "CAMS AUM" },
  { key: "karvy",           label: "KARVY AUM" },
  { key: "combined_aum",    label: "Combined AUM" },
  { key: "total_profit_loss", label: "Total Profit / Loss" },
];

export const CLIENTWISE_CARDS = [
  { key: "clients_in_view", label: "Clients in View" },
  { key: "cams_aum",        label: "CAMS AUM" },
  { key: "karvy_aum",       label: "KARVY AUM" },
  { key: "combined_aum",    label: "Combined AUM" },
];

const readAll = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}"); }
  catch { return {}; }
};

const writeAll = (val) => {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(val || {})); } catch { /* quota */ }
  window.dispatchEvent(new CustomEvent("kinntegra:hidden-cards-change"));
};

export function useHiddenCards(page) {
  const [hidden, setHidden] = useState(() => (readAll()[page] || {}));

  useEffect(() => {
    const sync = () => setHidden(readAll()[page] || {});
    window.addEventListener("kinntegra:hidden-cards-change", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("kinntegra:hidden-cards-change", sync);
      window.removeEventListener("storage", sync);
    };
  }, [page]);

  const toggle = useCallback((cardKey, isHidden) => {
    const all = readAll();
    const pageMap = { ...(all[page] || {}) };
    if (isHidden) pageMap[cardKey] = true;
    else delete pageMap[cardKey];
    all[page] = pageMap;
    writeAll(all);
    setHidden(pageMap);
  }, [page]);

  return { hidden, toggle };
}
